import OnePageCheckoutStateExt from "@dana/Store/Pages/OnePageCheckoutExt/OnePageCheckoutStateExt";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

const initialState: OnePageCheckoutStateExt = {
    isCarrierAccountRequired: false,
    carrierAccountNumber:  "",   
    editableNotes: "",
    additionalEmails:"",
    shipComplete:false,
};

const reducer = {   
    "Pages/OnePageCheckout/SetAdditionalEmails":(
        draft: Draft<OnePageCheckoutStateExt>,
        action: { additionalEmails: string },
    )=>{
        draft.additionalEmails = action.additionalEmails;
    },
    "Pages/OnePageCheckout/SetOrderNotes":(
        draft: Draft<OnePageCheckoutStateExt>,
        action: { orderNotes: string },
    )=>{
        draft.editableNotes = action.orderNotes;
    }, 
    "Pages/OnePageCheckout/SetCarrierAccountNumber":(
        draft: Draft<OnePageCheckoutStateExt>,
        action: { carrierAccountNumber: string },
    )=>{
        draft.carrierAccountNumber = action.carrierAccountNumber;
    },

    "Pages/OnePageCheckout/SetIsCarrierAccountRequired":(
        draft: Draft<OnePageCheckoutStateExt>,
        action: { isCarrierAccountRequired: boolean },
    )=>{
        draft.isCarrierAccountRequired = action.isCarrierAccountRequired;
    },
    
    "Pages/OnePageCheckout/SetShipComplete":(
        draft: Draft<OnePageCheckoutStateExt>,
        action: { isshipComplete: boolean },
    )=>{
        draft.shipComplete = action.isshipComplete;
    },
    
};

const onePageCheckoutPageExtReducer = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).onePageCheckoutStateExt = onePageCheckoutPageExtReducer;
type OnePageCheckoutExtReducers ={
    onepageCheckoutCustomReducer:typeof onePageCheckoutPageExtReducer;
};
export type onePageCheckoutCustom = Parameters<OnePageCheckoutExtReducers[keyof OnePageCheckoutExtReducers]>[1] | AnyAction;

